import { PlaceGalleryController } from './place-gallery.controller';

export const PlaceGalleryComponent: ng.IComponentOptions = {
  bindings: {
    place: '<',
  },
  templateUrl: 'places/place/components/place-gallery/place-gallery.html',
  controller: PlaceGalleryController,
};
